<template>
  <customModal :containerxxl=true :bodyxl = true :footerShow = true @closeModal="closeModal">
    <template #title>
       <h4 class="my-0">Issue Log</h4>
    </template>
    <template #body>
      <form >
        <div class="ibox-content bg-light mb-2 py-2">
            <div class=" d-flex justify-content-between row">
                <span class="col-md-6"> Closed By : <b>{{ riskDetails.closedUserEmail }}</b> </span>
                <span class="col-md-5"> Closed Date : <b>{{ filter(riskDetails.closedDate) }}</b></span>
                <span class="col-md-1 label label-primary py-1 text-center">{{ riskDetails.status }}</span>
                <div class="row">
                    
                </div>
                
            </div>
            
        </div>   
        <div class="ibox-content mb-2">
            <div class="form-row">
            <div class="col-lg-8 mb-2">
                <div class="row">          
                    <div class="col-lg-6 mb-1">
                        <label class="mb-0">{{ $t('navigations.issue log id') }} </label>
                        <input
                            type="text"
                            maxlength="1000"
                            class="form-control"
                            v-model="riskDetails.riskId"
                            disabled/>
                    </div>
                    <div class="col-lg-6 mb-1">
                        <label class="mb-0">{{ $t('navigations.risk name') }} </label>
                        <input type="text"  maxlength="1000" class="form-control" v-model="riskDetails.riskName"/>
                    </div>
                    <div class="col-lg-12 mb-1">
                        <label class="mb-0">{{ $t('navigations.mitigation plan') }}</label>
                        <textarea class="custom-textarea" rows="4" v-model="riskDetails.mitigationPlan"></textarea>
                    </div>
                </div>  
            </div>
            <div class="col-lg-4 mb-2">
                <div class="row">          
                    <div class="col-lg-12 mb-1">
                        <label class="mb-0">{{ $t('navigations.resolved date') }} </label>
                        <input type="date"  maxlength="1000" class="form-control" v-model="riskDetails.resolvedDate" disabled/>
                    </div>
                    <div class="col-lg-12 mb-1">
                        <label class="mb-0">{{ $t('navigations.resolved by') }} </label>
                        <input type="text"  maxlength="1000" class="form-control" v-model="riskDetails.resolvedUserEmail" disabled/>
                    </div>
                    <div class="col-lg-12 mb-1">
                        <label class="mb-0">{{ $t('navigations.status') }} </label>
                        <select class="form-control" v-model="riskDetails.status">
                            <option value="Open">Open </option>
                            <option value="In progress"> In progress</option>
                            <option value="Closed">Closed </option>
                            <option value="Resolved">Resolved</option>
                        </select>
                    </div>
                </div>
            </div>
            </div>
        </div>
 
        <div class="ibox-title d-flex justify-content-between align-items-center bg-light">
            <h5 class="mb-3">Task Info</h5>
            <div class="position-relative" aria-label="Create Task">
                 <img
                    class="cursor-pointer"
                    src="../../assets/img/create.png"
                    width="17" height="17" alt="Create Task"
                    @click="openModal()"
                />
                <div class="tool-tip">Create Task</div>
            </div>
        </div>
        <div class="ibox-content mb-2 px-2 py-2">
        <!-- <table class="table table-bordered table-hover mb-3">
            <thead class="thead-light">
                <tr>
                    <th class="text-center">{{ $t('navigations.task id') }}</th>
                    <th>{{ $t('navigations.title') }}</th>
                    <th>{{ $t('navigations.priority') }}</th>
                    <th>{{ $t('navigations.owner') }}</th>
                    <th>{{ $t('navigations.start date') }}</th>
                    <th>{{ $t('navigations.end date') }}</th>
                    <th>{{ $t('navigations.status') }}</th>
                    <th class="text-center">{{ $t('navigations.edit') }}</th>
                    <th class="text-center">{{ $t('navigations.delete') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="task in riskDetails.taskList" :key="task.id">
                    <td class="text-center">{{ task.taskID }}</td>
                    <td>{{ task.taskTitle }}</td>
                    <td>{{ task.priority }}</td>
                    <td>{{ task.owner }}</td>
                    <td>{{ filter(task.startDate) }}</td>
                    <td>{{ filter(task.endDate) }}</td>
                    <td>{{ task.status }}</td>
                    <td class="text-center">
                        <i class="fa fa-edit edit-delete" @click="openModal(task)"></i>
                    </td>
                    <td class="text-center">
                        <i class="fa fa-trash cursor-pointer" @click="deletetask(task, riskDetails.id)"></i>
                    </td>
                </tr>
            </tbody>
        </table> -->
        <!-- table class added -->
            <div class="rbqm-table mb-2" role="rbqm-table" aria-label="Risk Assessment rbqm-table">
                                <div class="rbqm-thead" role="row">
                                    <div class="cell" role="columnheader">{{ $t('navigations.task id') }}</div>
                                    <div class="cell" role="columnheader">{{ $t('navigations.title') }}</div>
                                    <div class="cell" role="columnheader">{{ $t('navigations.priority') }}</div>
                                    <div class="cell" role="columnheader">{{ $t('navigations.owner') }}</div>
                                    <div class="cell" role="columnheader">{{ $t('navigations.role') }}</div>
                                     <div class="cell" role="columnheader">{{ $t('navigations.start date') }}</div>
                                    <div class="cell" role="columnheader">{{ $t('navigations.end date') }}</div>
                                    <div class="cell" role="columnheader">{{ $t('navigations.status') }}</div>
                                    <div class="cell text-center" role="columnheader">{{ $t('navigations.edit') }}</div>
                                    <div class="cell text-center" role="columnheader">{{ $t('navigations.delete') }}</div>
                                </div>

                                <!-- <div v-if="!selectedRows.length" class="rbqm-row" role="row">
                                    <div class="cell" role="cell" style="grid-column: 1 / -1; color:#6b7280; padding:10px">
                                        Select a subcategory on the left to see its risks here.
                                    </div>
                                </div> -->

                                <!-- dynamic rows -->
                                <div class="rbqm-row" role="row"  v-for="task in riskDetails.taskList" :key="task.id">
                                    <div class="cell" role="cell"> {{ task.taskID }} </div>
                                    <div class="cell" role="cell"> {{ task.taskTitle }} </div>
                                    <div class="cell" role="cell">{{ task.priority }}</div>
                                    <div class="cell" role="cell">{{ (task.owner || []).join(', ') }}</div>
                                    <div class="cell" role="cell">
                                        {{ (task.ownerRoles || []).map(r => r.roleName).join(', ') }}
                                    </div>
                                    <div class="cell" role="cell"> {{ filter(task.startDate) }} </div>
                                    <div class="cell" role="cell"> {{ filter(task.endDate) }} </div>
                                    <div class="cell" role="cell"> {{ task.status }} </div>
                                    <div class="cell text-center" role="cell">
                                        <i class="fa fa-edit edit-delete" @click="openModal(task)"></i>
                                    </div>
                                    <div class="cell text-center" role="cell">
                                        <i class="fa fa-trash edit-delete" @click="deletetask(task,riskDetails.id)"></i>
                                    </div>
                                </div>
            </div>
        </div>
        <div class="ibox-content mb-2">
            <div class="form-row">
                <div class="col-12 col-md-6 mb-2">
                    <label for="roleList" class="form-label">{{$t("navigations.role")}}</label>
                    <Multiselect
                        id="roleList"
                        @select="onSelectClosed()"
                        @clear="onClear()"
                        @deselect="onSelectClosed()"
                        v-model="riskDetails.roles"
                        mode="multiple"
                        valueProp="roleID"
                        placeholder="Select roles"
                        :options="roleList"
                        :hide-selected="false"
                        :close-on-select="false"
                        :searchable="true"
                        class="multiselect-theme"
                    >
                        <template v-slot:option="{ option }">
                            {{ option.roleName }}
                        </template>
                    </Multiselect>
                </div>
                <div class="col-12 col-md-6 mb-2">
                    <label for="recipients" class="form-label">{{$t("navigations.responsibleOwner")}}</label>
                    <Multiselect
                        @clear="onRecipientClear()"
                        id="recipients"
                        valueProp="email"
                        label="email"
                        mode="multiple"
                        placeholder="Select"
                        :options="userList"
                        :hideSelected="false"
                        :closeOnSelect="false"
                        class="multiselect-theme"
                        size="30"
                        v-model="riskDetails.responsibleOwner"
                    >
                    <template v-slot:option="{ option }">
                        <span >
                        {{ option.email }}
                        </span>
                    </template>
                    </Multiselect>
                </div>
                <div class="col-lg-12 mb-1">
                    <label class="mb-0">{{ $t('navigations.expected outcome') }}</label>
                    <textarea class="custom-textarea" rows="2" v-model="riskDetails.expectedOutcome"></textarea>
                </div>
                <div class="col-lg-12 mb-1">
                    <label class="mb-0">{{ $t('navigations.resource need') }}</label>
                    <textarea class="custom-textarea" rows="2" v-model="riskDetails.resourceNeed"></textarea>
                </div>
                <div class="col-lg-12 mb-1">
                    <label class="mb-0">{{ $t('navigations.lesson learned') }}</label>
                    <textarea class="custom-textarea" rows="2" v-model="riskDetails.lessonLearned"></textarea>
                </div>
                <div class="col-lg-12 mb-1">
                    <label class="mb-0">{{ $t('navigations.comments') }}</label>
                    <textarea class="custom-textarea" rows="2" v-model="riskDetails.comments"></textarea>
                </div>
            </div>
        </div>
              <div class="ibox-content mb-2">
            <div class="ibox-title bg-light">
                <h5 class="mb-0"> {{ $t('navigations.evidence documents') }}</h5>
            </div>
            <div class="ibox-content">
                <input
                accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf"
                id="InPutFile"
                type="file"
                class="form-control my-2 my-lg-0"
                @change="previewFiles"
                />
                <span
                    class="label px-2 mt-2" style="display: inline-block; margin-right: 6px;"
                    v-for="(eachfiles, index) in fileList"
                    :key="eachfiles"
                >
                    <span class="listfile breakWord px-1" style="display: inline-block; margin-right: 6px;">
                        <a>
                            {{ eachfiles }}
                            <i
                            class="fa fa-close pl-2"
                            @click.prevent="removefile(index)"
                            ></i
                        ></a>
                    </span>
                </span>
            </div>
        </div>
      </form>
    </template>
    <template #footer>
        <div class="d-flex justify-content-end p-2 gap-2">
            <button 
                type="submit" 
                class="btn btn-sm btn-outline-success py-1"  
                @click="updateStatus('Closed')">{{ $t('navigations.close') }}
            </button>
            <button 
                type="submit" 
                class="btn btn-sm btn-outline-primary py-1"  
                @click="updateRisk(riskDetails.status)">{{ $t('navigations.save changes') }}
            </button>
            <button 
                type="submit" 
                class="btn btn-sm btn-outline-primary py-1"  
                @click="updateStatus('Resolved')">{{ $t('navigations.resolve') }}
            </button>
            <button 
                type="submit" 
                class="btn btn-sm btn-outline-primary py-1"  
                @click="updateStatus('Closed and Resolved')">{{ $t('navigations.resolve and close') }}
            </button>
            
        </div>
    </template>
  </customModal>

  <manageRiskTaskModal
    v-show="showTaskModal"
    :riskRegId="riskDetails.id"
    :tskId="taskId"
    @closeModal="closeTaskManageModal"
    @refreshData="refreshTasks"
  />
</template>

<script src="./ManageRiskRegisterModal.js"></script>

<style scoped>

.custom-textarea:focus-visible{
    outline: 1px solid #9ca2a8;
}
.custom-textarea{
    border: 1px solid #ced4da;
}
.rbqm-table {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    overflow: hidden;
}

.rbqm-thead,
.rbqm-row {
    display: grid;
    grid-template-columns: 80px 1fr 90px 200px 200px 90px 90px 90px 40px 50px;
    align-items: center;
}
.rbqm-row{
    border-top: 1px solid #e5e7eb
}

.rbqm-thead {
    background: #fbfcfe;
    color: var(--muted);
    font-weight: 600;
    letter-spacing: .2px;
    border-bottom: 1px solid #e5e7eb;
    padding: 4px 0px;
}

.cell {
    padding: 4px 4px
}

/* left index pill */
.index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: #2f6fb5;
    color: #fff;
    font-weight: 600;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}

</style>